import React from 'react';
import { withTranslation } from 'react-i18next';

import { AdvancedSearch } from './AdvancedSearch/AdvancedSearch';

import './SearchBar.css';

import minus from './../../../assets/icons/minus.svg';
import plus from './../../../assets/icons/plus.svg';

const SearchBar = ({ 
  updateState,
  t,
  showTag,
  approvalsSelectedGUID,
  showAdvancedSearch,
  setShowAdvancedSearch,
  children
}) => {
  const handleClick = () => {
    sessionStorage.setItem('showAdvancedSearchApprovals', !showAdvancedSearch);
    setShowAdvancedSearch(!showAdvancedSearch);
  };

  return (
    <>
      <div className="bar-container">
        <button className="advanced-search" onClick={handleClick}>
          <span>{t('documents.advanced-search')}</span>
          <div>
            {showAdvancedSearch ? <img src={minus} alt="Hide"/> : <img src={plus} alt="Show"/>}
          </div>
        </button>
        {children}
      </div>
      {
        showAdvancedSearch ? <AdvancedSearch
          updateState={updateState}
          showTag={showTag}
          approvalsSelectedGUID={approvalsSelectedGUID}
        /> : null
      }
    </>
  );
}

export default withTranslation()(SearchBar);